import Gameboard from "./Gameboard";

export default Gameboard;